type CAF = (args?: CAFArgs) => unknown;
type CAFArgs = unknown;

export const getFirstIfArray = <T>(arg: T | T[]): T =>
  Array.isArray(arg) ? arg[0] : arg;

export const isEmpty = (object: unknown) => {
  if (!object) return true;
  if (Array.isArray(object)) return !object.length;
  return !Object.keys(object).length;
};

export const isBrowser = () => {
  if (typeof window === "undefined") {
    return false;
  }
  return true;
};

export function hexToRGB(hex: string, alpha: number) {
  const r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
  } else {
    return "rgb(" + r + ", " + g + ", " + b + ")";
  }
}

export const callAllEach =
  (...fns: CAF[]) =>
  (...args: CAFArgs[]): void => {
    fns.forEach((fn) => fn && fn(...args));
  };
